<template>
    <div class="header-wrap">
        <div class="header">
            <div class="logo"><img src="../assets/images/logo.png"></div>
            <div class="main">{{gameInfo.name}}</div>
            <div class="u-info" v-if="userInfo&&userInfo.userName">{{userInfo && userInfo.userName}} <img :src="userInfo && userInfo.headpic" /></div>
            <div class="exit" v-if="userInfo&&userInfo.userName" @click="logout">Change Account</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageHeader",
        props: {
            loginUrl: String,
            userInfo: Object,
            gameInfo: Object,
        },
        methods: {
            logout() {
                this.$emit('logout')
            }
        },
    }
</script>

<style lang="scss" scoped>
    .header-wrap {
        width: 100%;
        height: 102px;
        background: #20196B;
        margin-bottom: 65px;
    }
    .header {
        width: 1220px;
        height: 102px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        .logo {
            width: 210px;
            img {
                width: 210px;
            }
        }
        .main {
            flex: 1;
            text-align: center;
            font-size: 24px;
            color: #fff;
        }
        .u-info {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #fff;
            img {
                width: 28px;
                height: 28px;
                border-radius: 50%;
                margin-left: 4px;
            }
        }
        .exit {
            color: #fff;
            margin-left: 10px;
            cursor: pointer;
        }
    }
</style>
